import { useRouter as useRouterFromExpoRouter } from "expo-router";
import type { ImperativeRouter } from "expo-router";

/**
 * Returns the router object for the current context.
 *
 * Dynamic route params must be passed unencoded — Expo Router encodes them when
 * building the URL. Pre-encoding here caused double-encoded segments (e.g.
 * `%25E4%25BA%258C` for 二). Decode on read via `resolveRouteParam`.
 */
export function useRouter(): ImperativeRouter {
  return useRouterFromExpoRouter();
}
